import { connect } from 'react-redux';
import { selectors as flagSelectors } from 'dux/user';

import NoInstancesPage from './NoInstancesPage';

const mapStateToProps = (state) => ({
  createString: flagSelectors.createStringSelector(state),
});

export default connect(mapStateToProps, null)(NoInstancesPage);
